module.exports = __webpack_public_path__ + "static/media/Oil-red.d3ff94a0.svg";